// ##### Komarov 2025-07-18
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalizedText } from '../../../../hooks/useLocalizedText.js';
// ##### Komarov 2025-07-19
import { setPaxListOpen } from '../../../../Redux/actions/paxchoice.js';

// ##### Komarov 2025-07-14
const HotelsPaxChoicePopUpButtonPageDevices = ({ marginTop = null }) => {
  // ##### Komarov 2025-08-05
  const Confirm = useLocalizedText('Confirm');

  // ##### Komarov 2025-07-18
  const dispatch = useDispatch();

  // ##### 24-03-21 Komarov
  return (
    <button
      data-component="HotelsPaxChoicePopUpButtonPageDevices"
      type="button"
      className="PopUpButton"
      // ##### 23-04-28 Komarov
      onClick={e => {
        dispatch(setPaxListOpen(false));
        e.stopPropagation();
      }}
      // ##### 23-09-14 Komarov
      style={{ marginTop }}
    >
      {
        // ##### 23-10-04 Komarov
        Confirm
      }
    </button>
  );
};

// ##### 25-05-21 Komarov
export default HotelsPaxChoicePopUpButtonPageDevices;
